<template>
  <div class="app-container">
    <div class="filter-container">
      <el-button class="filter-item" type="primary" @click="handleCreate">新增</el-button>

      <el-select v-model="listQuery.is_on" placeholder="状态" style="width: 120px" class="filter-item" clearable>
        <el-option label="下架" :value="0" />
        <el-option label="正常" :value="1" />
      </el-select>

      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" fit highlight-current-row>
      <el-table-column label="满额条件" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.minimum }}
        </template>
      </el-table-column>

<!--      <el-table-column label="赠送优惠券额度" min-width="110" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          {{ scope.row.coupon_limit }}-->
<!--        </template>-->
<!--      </el-table-column>-->

      <el-table-column label="赠送优惠券包" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.coupon_product ? `${scope.row.coupon_product.name}（￥${scope.row.coupon_product.discount_total}---${scope.row.coupon_product.num_total}张）` : "无" }}
        </template>
      </el-table-column>

      <el-table-column label="赠送余额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.balance_limit }}
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_on" type="success">正常</el-tag>
          <el-tag v-else type="danger">下架</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">修改</el-button>

          <el-button type="danger" size="mini" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30, 50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="150px">
        <el-form-item label="满额条件" prop="minimum">
          <el-input-number size="small" v-model="form.minimum" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

<!--        <el-form-item label="赠送优惠券额度" prop="coupon_limit">-->
<!--          <el-input-number size="small" v-model="form.coupon_limit" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>-->
<!--        </el-form-item>-->

        <el-form-item label="赠送优惠券包" prop="coupon_product_id">
          <el-select size="small" v-model="form.coupon_product_id" placeholder="请选择赠送优惠券包" filterable clearable>
            <el-option :key="0" label="无" :value="0"></el-option>
            <el-option v-for="item in couponProductList" :key="item.id" :label="`${item.name}（￥${item.discount_total}---${item.num_total}张）`" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="赠送余额" prop="balance_limit">
          <el-input-number size="small" v-model="form.balance_limit" :min="0" :precision="0" style="width: 100%;max-width: 220px;"></el-input-number>
        </el-form-item>

        <el-form-item label="状态" prop="is_on">
          <el-switch v-model="form.is_on" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0">
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from "@/utils/request";
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        list: null,
        total: null,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          school_id: "",
          is_on: "",
        },
        dialogFormVisible: false,
        dialogStatus: "",
        textMap: {
          update: "修改",
          create: "新增",
        },
        btnLoading: false,
        form:{
          id: "",
          school_id: "",
          minimum: undefined,
          coupon_limit: 0,
          coupon_product_id: undefined,
          balance_limit: undefined,
          is_on: 1,
        },
        rules: {
          minimum: [{ required: true, message: "满额条件不能为空", trigger: "blur" }],
          coupon_limit: [{ required: true, message: "赠送优惠券额度不能为空", trigger: "blur" }],
          coupon_product_id: [{ required: true, message: "赠送优惠券包不能为空", trigger: "change" }],
          balance_limit: [{ required: true, message: "赠送余额不能为空", trigger: "blur" }],
          is_on: [{ required: true, message: "状态不能为空", trigger: "blur" }],
        },
        // 优惠券包列表
        couponProductList: null
      };
    },
    created() {
      this.getList();
      this.getCouponProductList();
    },
    computed: {
      ...mapGetters(["schools","school_id","user"])
    },
    watch: {
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
        this.getCouponProductList();
      },
    },
    methods: {
      getList() {
        this.listQuery.school_id = this.school_id;
        this.listLoading = true;
        request({
          url: "/api/backend/rechargeConfig/list",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.list = response.data.data;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      getCouponProductList() {
        request({
          url: "/api/backend/couponProduct/list",
          method: "get",
          params: {
            page: 1,
            limit: 100000,
            school_id: this.school_id,
          }
        }).then(response => {
          this.couponProductList = response.data.data;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      resetForm() {
        this.form = {
          id: "",
          school_id: "",
          minimum: undefined,
          coupon_limit: 0,
          coupon_product_id: undefined,
          balance_limit: undefined,
          is_on: 1,
        }
        this.btnLoading = false;
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = "create"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = "update"
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs["form"].clearValidate() //清除校验结果
        })
      },
      saveData() {
        if (!this.school_id) {
          this.$message({
            type: "warning",
            message: "请选择学校"
          });
          return;
        } else {
          this.form.school_id = this.school_id
        }
        this.$refs["form"].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: "/api/backend/rechargeConfig/save",
              method: "post",
              data: this.form
            }).then(() => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$message({
                type: "success",
                message: "操作成功"
              });
              this.getList();
            }).catch(() => {
              this.btnLoading = false
            })
          }
        })
      },
      handleDelete(row) {
        this.$confirm("确定继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/rechargeConfig/delete",
            method: "post",
            data: {id: row.id},
          }).then(() => {
            this.$message({
              type: "success",
              message: "操作成功"
            });
            this.getList();
          })
        }).catch((err) => {
          console.log(err)
        });
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
